import { createSvgIcon } from '@mui/material';

export const MenuIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M4 16v-2h16v2H4Zm0-6V8h16v2H4Z" />
  </svg>,
  'MenuIcon',
);
